import { authPost } from "../../common/redux/ApiClient";

const baseUrl = "http://35.240.204.237/ok99memberApi/api";

export function mbPromotionPageList(queryParams) {
  return authPost(`${baseUrl}/Member7/PromotionList`, queryParams);
}
